/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Type_SubwayInputs */

const fr_vehicle_type_subway = /** @type {(inputs: Vehicle_Type_SubwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métro`)
};

const en_vehicle_type_subway = /** @type {(inputs: Vehicle_Type_SubwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metro`)
};

/**
* | output |
* | --- |
* | "Metro" |
*
* @param {Vehicle_Type_SubwayInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_type_subway = /** @type {((inputs?: Vehicle_Type_SubwayInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Type_SubwayInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_type_subway(inputs)
	return en_vehicle_type_subway(inputs)
});